import { render, staticRenderFns } from "./NoticePanel.vue?vue&type=template&id=c309c868&scoped=true"
import script from "./NoticePanel.vue?vue&type=script&lang=js"
export * from "./NoticePanel.vue?vue&type=script&lang=js"
import style0 from "./NoticePanel.vue?vue&type=style&index=0&id=c309c868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c309c868",
  null
  
)

export default component.exports